<section>

    <div id="prueba">
        
        
        <h1><strong> {{evento?.nombre}}</strong></h1> 
        <small class="float-right "><strong>Pulep:</strong> {{evento?.id}}</small>
        
        
    </div>
</section>

<section class="container-fluid">
  <div class="row">
    <div class="col-12">
      <form (ngSubmit)="!todoForm.invalid && buscarCliente()" class="mt-4" #todoForm="ngForm">
      <h3>Numero De Documento</h3>
      <input type="text" class= "form-control "name ="id" placeholder="Numero de documento de cliente" required="required"  [(ngModel)]="ccDeBusqueda">
      <button class="btn btn-success mt-2"   type="submit">Buscar</button>
    </form>
    </div>
    <div class="col-12">
      <h3>Datos del cliente encontrado:</h3>
      <h4><strong>Nombre:</strong> {{usuarioEntidad?.nombre}}</h4>
      <h4><strong>Correo:</strong>{{usuarioEntidad?.correo}} </h4>
      <h4><strong>Celular:</strong>{{usuarioEntidad?.celular}} </h4>
    </div>
  </div>
</section>
<section class="container-fluid mt-5" >
    <div class="row " >
      <div class="col-12">
        <p *ngIf="evento?.mapa =='mapa3'"><span class="cuadros cuadros10">#</span> PALCOS A</p>
        <p *ngIf="evento?.mapa =='mapa3'"><span class="cuadros5 cuadros">#</span> Palcos B</p>
        <p *ngIf="evento?.mapa =='mapa3'"><span class="colorVIP cuadros"></span>VIP</p>
        <p *ngIf="evento?.mapa =='mapa3'"><span class="cuadros4 cuadros"></span>GENERAL</p>
        <p *ngIf="evento?.mapa =='mapa22'"><span class="cuadros7 cuadros">#</span>PATROCINADORES</p>
        <p *ngIf="evento?.mapa =='mapa22'"><span class="cuadros12 cuadros">#</span>MONASTERY</p>
        <p *ngIf="evento?.mapa =='mapa22'"><span class="cuadros10 cuadros">#</span>CHIMBITA</p>
        <p *ngIf="evento?.mapa =='mapa22'"><span class="cuadros8 cuadros">#</span>FUMETEO</p>
        <p *ngIf="evento?.mapa =='mapa22'"><span class="cuadros13 cuadros">#</span>ZONA FRIKI</p>
        <p *ngIf="evento?.mapa =='mapa22'"><span class="cuadros14 cuadros">#</span>ZONA JORDAN</p>
        <p *ngIf="evento?.mapa =='mapa22'"><span class="cuadros5 cuadros">#</span>VACACIONES ZONA DE MENORES</p>
        <p *ngIf="evento?.mapa =='mapa22'"><span class="cuadros rojo">v</span>Vendido</p>
        <p *ngIf="evento?.mapa =='mapa22'"><span class="cuadros amarillo">p</span>En Proceso de compra</p>

        <p *ngIf="evento?.mapa =='mapa1'"><span class="cuadros cuadros10">#</span> Palcos Adicta al dolor</p>
        <p *ngIf="evento?.mapa =='mapa1'"><span class="cuadros5 cuadros">#</span> Zona Collar de Perlas</p>
        <p *ngIf="evento?.mapa =='mapa1'"><span class="cuadros4 cuadros">#</span>Zona Días Nublados</p>
        <p *ngIf="evento?.mapa =='mapa1'"><span class="cuadros rojo">v</span>Vendido</p>
        <p *ngIf="evento?.mapa =='mapa1'"><span class="cuadros amarillo">p</span>En Proceso de compra</p>
      </div>
    

   


    </div>
  </section>





  
<div id="desplazate" *ngIf="evento?.mapa=='mapa1'">
  <p>
    <-- Desplázate en el mapa -->
  </p>
</div>
<div class="contenedor-mapa mt-5 pb-5" *ngIf="evento?.mapa=='mapa1'">
  
  <div class="mapa mg-0">

    <div class="tarimaMp1">ESCENARIO</div>
    <div class="clearFix"></div>

    <div class="contmap1">
      <div *ngFor="let item of lista1">
        <div class="cuadrosSemiGrandes"
          [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
          (click)="agregarPalcoIndividual(item.valor)">
          {{item.valor}}
        </div>
      </div>
    </div>
    <div class="clearFix"></div>
    <div class="zonaPerla" (click)="abrirTickets(localidadCargadaBoletasVIP)">Zona Collar de Perlas</div>
    <div class="clearFix"></div>
    <div class="zonaNublado" (click)="abrirTickets(localidadCargadaBoletas)">Zona Días Nublados</div>

  </div>
</div>



<div class="contenedor-mapa mt-5 pb-5" *ngIf="evento?.mapa=='mapa3'">
  
  <div class="mapa mg-0">
    <div class="tarimaPerreo">ESCENARIO PRINCIPAL</div>
    <div class="clearFix"></div>
    <div *ngFor="let item of lista5" class="margen-90" >
      <div class="cuadros"
        [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
        (click)="agregarPalcoIndividual(item.valor)">
        {{item.valor}}
      </div>
    </div>
    <div class="clearFix"></div>


<div class="flotar">
    <div *ngFor="let item of lista3"  >
      <div class="cuadrosSinf"
        [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
        (click)="agregarPalcoIndividual(item.valor)">
        {{item.valor}}
      </div>
    </div>
  </div>
  <div class="flotar">
    <div *ngFor="let item of lista1" >
      <div class="cuadrosSinf"
        [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
        (click)="agregarPalcoIndividual(item.valor)">
        {{item.valor}}
      </div>
    </div>
    </div>
    <div class="localidadLibreCuadroVIP"(click)="abrirTickets(localidadCargadaPreferecial)"></div>
    <div class="flotar">
    <div *ngFor="let item of lista2 " >
      <div class="cuadrosSinf"
        [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
        (click)="agregarPalcoIndividual(item.valor)">
        {{item.valor}}
      </div>
    </div>
    </div>
    
   
    <div class="flotar">
    <div *ngFor="let item of lista4"  >
      <div class="cuadrosSinf"
        [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
        (click)="agregarPalcoIndividual(item.valor)">
        {{item.valor}}
      </div>
    </div>
    </div>
    
    <div class="clearFix"></div>
  
    <div class="localidadLibreLargaVIP" (click)="abrirTickets(localidadCargadaPreferecial)">VIP</div>

    <div class="clearFix"></div>
  
      <div class="localidadLibre" (click)="abrirTickets(localidadCargadaBoletas)">General</div>
      <div class="clearFix"></div>
  
      <div class="localidadLibreCuadro" (click)="abrirTickets(localidadCargadaBoletas)"></div>
  </div>
</div>





<div class="contenedor-mapa-largo mt-5 pb-5" *ngIf="evento?.mapa=='mapa4'">

  
  <div class="mapa-largo mg-0">
    
    <div *ngFor="let item of lista1" class="margenPF">
      <div class="cuadros"
        [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem', 'seleccionado':item.seleccionado==true}"
        (click)="seleccionarTicketExacto(item)">
        {{item.valor}}
      </div>
    </div>
    <div class="clearFix"></div>
    
    <div *ngFor="let item of lista2; let i = index" >
      <div class="cuadros"
        [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem' , 'margenF6':i==9 ,'margenF': i ==24|| i ==19  , 'seleccionado':item.seleccionado==true}"
        (click)="seleccionarTicketExacto(item)">
        {{item.valor}}
      </div>
    </div>

    <div class="clearFix"></div>
    
    <div *ngFor="let item of lista3; let i = index" class="margenF">
      <div class="cuadros"
        [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem' , 'margenF6':i==8 , 'seleccionado':item.seleccionado==true}"
        (click)="seleccionarTicketExacto(item)">
        {{item.valor}}
      </div>
    </div>
    <div class="clearFix"></div>
    
    <div *ngFor="let item of lista4; let i = index" class="margenF">
      <div class="cuadros"
        [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem',  'margenF6': i ==24 || i==8 , 'seleccionado':item.seleccionado==true}"
        (click)="seleccionarTicketExacto(item)">
        {{item.valor}}
      </div>
    </div>

    <div class="clearFix"></div>
    
    <div *ngFor="let item of lista5; let i = index" class="margenF">
      <div class="cuadros"
        [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem', 'margenF6':i==7 , 'margenF': i==10 || i==23, 'margenF11': i ==22, 'seleccionado':item.seleccionado==true}"
        (click)="seleccionarTicketExacto(item)">
        {{item.valor}}
      </div>
    </div>

    <div class="clearFix"></div>
    
    <div *ngFor="let item of lista6; let i = index"class="margenF">
      <div class="cuadros"
        [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem', 'margenF':i==23  ,'margenF2': i ==25, 'margenF6': i==7, 'seleccionado':item.seleccionado==true}"
        (click)="seleccionarTicketExacto(item)">
        {{item.valor}}
      </div>
    </div>


    <div class="clearFix"></div>
    
    <div *ngFor="let item of lista7; let i = index" class="margenF">
      <div class="cuadros"
        [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem', 'margenF6': i ==26 || i==6, 'seleccionado':item.seleccionado==true}"
        (click)="seleccionarTicketExacto(item)">
        {{item.valor}}
      </div>
    </div>

    <div class="clearFix"></div>
    
    <div *ngFor="let item of lista8; let i = index" class="margenF">
      <div class="cuadros"
        [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem', 'margenF3':i==8, 'seleccionado':item.seleccionado==true}"
        (click)="seleccionarTicketExacto(item)">
        {{item.valor}}
      </div>
    </div>
    <div class="clearFix"></div>
    
    <div *ngFor="let item of lista9; let i = index"  class="margenF">
      <div class="cuadros"
        [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem', 'margenF5':i==7, 'seleccionado':item.seleccionado==true}"
        (click)="seleccionarTicketExacto(item)">
        {{item.valor}}
      </div>
    </div>
    <div class="clearFix"></div>
    
    <div *ngFor="let item of lista10; let i = index" class="margenF" >
      <div class="cuadros"
        [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem', 'margenF5':i==7, 'seleccionado':item.seleccionado==true}"
        (click)="seleccionarTicketExacto(item)">
        {{item.valor}}
      </div>
    </div>
    <div class="clearFix"></div>
    
    <div *ngFor="let item of lista11; let i = index" class="margenF">
      <div class="cuadros"
        [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem', 'margenF16':i==6 ,'margenF6':  i==12, margenF11:i==18 , 'seleccionado':item.seleccionado==true}"
        (click)="seleccionarTicketExacto(item)">
        {{item.valor}}
      </div>
    </div>
    <div class="clearFix"></div>
    
    <div *ngFor="let item of lista12; let i = index"  class="margenF7">
      <div class="cuadros"
        [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem', 'margenF6':i==8, 'seleccionado':item.seleccionado==true}"
        (click)="seleccionarTicketExacto(item)">
        {{item.valor}}
      </div>
    </div>
    <div class="clearFix"></div>
    
    <div *ngFor="let item of lista13;let i = index"  class="margenF2" >
      <div class="cuadros"
        [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem', 'margenF2':i==5 ,'margenF11': i==22, 'seleccionado':item.seleccionado==true}"
        (click)="seleccionarTicketExacto(item)">
        {{item.valor}}
      </div>
    </div>
    <div class="clearFix"></div>
    
    <div *ngFor="let item of lista14" class="margenF17" >
      <div class="cuadros"
        [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem', 'seleccionado':item.seleccionado==true}"
        (click)="seleccionarTicketExacto(item)">
        {{item.valor}}
      </div>
    </div>
    <div class="clearFix"></div>
    
    <div *ngFor="let item of lista15" class="margenF17">
      <div class="cuadros"
        [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem', 'seleccionado':item.seleccionado==true}"
        (click)="seleccionarTicketExacto(item)">
        {{item.valor}}
      </div>
    </div>
    <div class="clearFix"></div>
    
    <div *ngFor="let item of lista16;let i = index" class="margenF8">
      <div class="cuadros"
        [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem', 'seleccionado':item.seleccionado==true}"
        (click)="seleccionarTicketExacto(item)">
        {{item.valor}}
      </div>
    </div>
    <div class="clearFix"></div>
    
    <div *ngFor="let item of lista17;let i = index"class="margenF9" >
      <div class="cuadros"
        [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem', 'seleccionado':item.seleccionado==true}"
        (click)="seleccionarTicketExacto(item)">
        {{item.valor}}
      </div>
    </div>

    <div class="clearFix"></div>
    
    <div *ngFor="let item of lista18;let i = index" class="margenF6">
      <div class="cuadros"
        [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem', 'margenF6':i==4, 'margenF16': i==21, 'seleccionado':item.seleccionado==true}"
        (click)="seleccionarTicketExacto(item)">
        {{item.valor}}
      </div>
    </div>

    <div class="clearFix"></div>
    
    <div *ngFor="let item of lista19;let i = index" class="margenF6" >
      <div class="cuadros"
        [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem',  'margenF16':i==5 || i==20, 'seleccionado':item.seleccionado==true}"
        (click)="seleccionarTicketExacto(item)">
        {{item.valor}}
      </div>
    </div>

    <div class="clearFix"></div>
    
    <div *ngFor="let item of lista20;let i = index" class="margenF16">
      <div class="cuadros"
        [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem' , 'margenF16':i==6,'margenF11': i==17, 'seleccionado':item.seleccionado==true}"
        (click)="seleccionarTicketExacto(item)">
        {{item.valor}}
      </div>
    </div>

    <div class="clearFix"></div>
    
    <div *ngFor="let item of lista21" class="margenF10">
      <div class="cuadros"
        [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros3':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem', 'seleccionado':item.seleccionado==true}"
        (click)="seleccionarTicketExacto(item)">
        {{item.valor}}
      </div>
    </div>

    <div class="clearFix"></div>
    
    <div *ngFor="let item of lista22" class="margenF13">
      <div class="cuadros"
        [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros3':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem', 'seleccionado':item.seleccionado==true}"
        (click)="seleccionarTicketExacto(item)">
        {{item.valor}}
      </div>
    </div>

    <div class="clearFix"></div>
    
    <div *ngFor="let item of lista23" class="margenF4">
      <div class="cuadros"
        [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros3':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem', 'seleccionado':item.seleccionado==true}"
        (click)="seleccionarTicketExacto(item)">
        {{item.valor}}
      </div>
    </div>

    <div class="clearFix"></div>
    
    <div *ngFor="let item of lista24;let i = index" class="margenF20">
      <div class="cuadros"
        [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros3':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem', 'seleccionado':item.seleccionado==true}"
        (click)="seleccionarTicketExacto(item)">
        {{item.valor}}
      </div>
    </div>
    <div class="clearFix"></div>
    
    <div *ngFor="let item of lista25"  class="margenF13" >
      <div class="cuadros"
        [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros3':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem', 'seleccionado':item.seleccionado==true}"
        (click)="seleccionarTicketExacto(item)">
        {{item.valor}}
      </div>
    </div>
    <div class="clearFix"></div>

    <div *ngFor="let item of lista31" >
      <div class="cuadros"
        [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros3':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem', 'seleccionado':item.seleccionado==true}"
        (click)="seleccionarTicketExacto(item)">
        {{item.valor}}
      </div>
    </div>

    <div *ngFor="let item of lista26; let i = index" >
      <div class="cuadros"
        [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros3':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem', 'margenF12':i==0, 'seleccionado':item.seleccionado==true}"
        (click)="seleccionarTicketExacto(item)">
        {{item.valor}}
      </div>
    </div>

    <div *ngFor="let item of lista34; let i = index" >
      <div class="cuadros"
        [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros3':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem', 'margenF15':i==0, 'seleccionado':item.seleccionado==true}"
        (click)="seleccionarTicketExacto(item)">
        {{item.valor}}
      </div>
    </div>
    <div class="clearFix"></div>

    <div *ngFor="let item of lista32" >
      <div class="cuadros"
        [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros3':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem', 'seleccionado':item.seleccionado==true}"
        (click)="seleccionarTicketExacto(item)">
        {{item.valor}}
      </div>
    </div>
    
    <div *ngFor="let item of lista27; let i = index" >
      <div class="cuadros"
        [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros3':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem', 'margenF20':i==0, 'seleccionado':item.seleccionado==true}"
        (click)="seleccionarTicketExacto(item)">
        {{item.valor}}
      </div>
    </div>

    <div *ngFor="let item of lista35; let i = index" >
      <div class="cuadros"
        [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros3':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem', 'margenF9':i==0, 'margenF':i==1, 'seleccionado':item.seleccionado==true}"
        (click)="seleccionarTicketExacto(item)">
        {{item.valor}}
      </div>
    </div>
    <div class="clearFix"></div>
    <div *ngFor="let item of lista33" >
      <div class="cuadros"
        [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros3':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem', 'seleccionado':item.seleccionado==true}"
        (click)="seleccionarTicketExacto(item)">
        {{item.valor}}
      </div>
    </div>
    <div *ngFor="let item of lista28; let i = index" >
      <div class="cuadros"
        [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros3':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem', 'margenF13':i==0, 'seleccionado':item.seleccionado==true}"
        (click)="seleccionarTicketExacto(item)">
        {{item.valor}}
      </div>
    </div>
    <div *ngFor="let item of lista36; let i = index" >
      <div class="cuadros"
        [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros3':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem', 'margenF10':i==0, 'seleccionado':item.seleccionado==true}"
        (click)="seleccionarTicketExacto(item)">
        {{item.valor}}
      </div>
    </div>
    <div class="clearFix"></div>
    
    <div *ngFor="let item of lista29; let i = index" >
      <div class="cuadros"
        [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros3':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem', 'margenF4':i==5, 'margenF9':i==16, 'seleccionado':item.seleccionado==true}"
        (click)="seleccionarTicketExacto(item)">
        {{item.valor}}
      </div>
    </div>
    <div class="clearFix"></div>
    
    <div *ngFor="let item of lista30" class="margenF21">
      <div class="cuadros"
        [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros3':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem', 'seleccionado':item.seleccionado==true}"
        (click)="seleccionarTicketExacto(item)">
        {{item.valor}}
      </div>
    </div>
    <div class="clearFix"></div>
    <button class="btn action_button mt-4" *ngIf="boletas.length>0" (click)="agregarAlCarritoTickets()">Agregar al carrito</button>
  </div>
</div>






<div id="desplazate" *ngIf="evento?.mapa=='mapa11'">
  <p>
    <-- Desplázate en el mapa -->
  </p>
</div>


<div class="contenedor-mapa-largo mt-5 pb-5" *ngIf="evento?.mapa=='mapa11'">
  <div class="mapa-largo mg-0">


    <div class="localidadB margencuadrito">

      <div *ngFor="let item of lista62">
        <div class="cuadros"
          [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
          (click)="agregarPalcoIndividual(item.valor)">
          {{item.valor}}
        </div>
      </div>
      <div class="clearFix"></div>
      <div *ngFor="let item of lista63">
        <div class="cuadros"
          [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
          (click)="agregarPalcoIndividual(item.valor)">
          {{item.valor}}
        </div>
      </div>
      <div class="clearFix"></div>
      <div *ngFor="let item of lista64">
        <div class="cuadros"
          [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
          (click)="agregarPalcoIndividual(item.valor)">
          {{item.valor}}
        </div>
      </div>
      <div class="clearFix"></div>
      <div *ngFor="let item of lista65">
        <div class="cuadros"
          [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
          (click)="agregarPalcoIndividual(item.valor)">
          {{item.valor}}
        </div>
      </div>
      <div class="clearFix"></div>
      <div *ngFor="let item of lista66">
        <div class="cuadros"
          [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
          (click)="agregarPalcoIndividual(item.valor)">
          {{item.valor}}
        </div>
      </div>
      <div class="clearFix"></div>
      <div *ngFor="let item of lista67">
        <div class="cuadros"
          [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
          (click)="agregarPalcoIndividual(item.valor)">
          {{item.valor}}
        </div>
      </div>

    </div>


    <div class="clearFix"></div>
    <div class="localidadA">
      <div *ngFor="let item of lista37" class="margencuadrito">
        <div class="cuadros2"
          [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
          (click)="agregarPalcoIndividual(item.valor)">
          {{item.valor}}
        </div>
      </div>
      <div class="clearFix"></div>
      <div *ngFor="let item of lista38" class="margencuadrito">
        <div class="cuadros2"
          [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
          (click)="agregarPalcoIndividual(item.valor)">
          {{item.valor}}
        </div>
      </div>
      <div class="clearFix"></div>
      <div *ngFor="let item of lista39" class="margencuadrito">
        <div class="cuadros2"
          [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
          (click)="agregarPalcoIndividual(item.valor)">
          {{item.valor}}
        </div>
      </div>
      <div class="clearFix"></div>
      <div *ngFor="let item of lista40" class="margencuadrito">
        <div class="cuadros2"
          [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
          (click)="agregarPalcoIndividual(item.valor)">
          {{item.valor}}
        </div>
      </div>
      <div class="clearFix"></div>
      <div *ngFor="let item of lista41" class="margencuadrito5">
        <div class="cuadros2"
          [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
          (click)="agregarPalcoIndividual(item.valor)">
          {{item.valor}}
        </div>
      </div>


      <!--ACA VA LA PF-->

      <div class="clearFix"></div>
      <div class="tarimaCuadrito">T</div>
      <div *ngFor="let item of lista53">
        <div class="cuadros2"
          [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
          (click)="agregarPalcoIndividual(item.valor)">
          {{item.valor}}
        </div>
      </div>

      <div *ngFor="let item of lista42">
        <div class="cuadros2"
          [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
          (click)="agregarPalcoIndividual(item.valor)">
          {{item.valor}}
        </div>
      </div>


      <div class="clearFix"></div>
      <div class="tarimaCuadrito">A</div>
      <div *ngFor="let item of lista54">
        <div class="cuadros2"
          [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
          (click)="agregarPalcoIndividual(item.valor)">
          {{item.valor}}
        </div>
      </div>

      <div *ngFor="let item of lista43">
        <div class="cuadros2"
          [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
          (click)="agregarPalcoIndividual(item.valor)">
          {{item.valor}}
        </div>
      </div>
      <div class="clearFix"></div>
      <div class="tarimaCuadrito">R</div>
      <div *ngFor="let item of lista55">
        <div class="cuadros2"
          [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
          (click)="agregarPalcoIndividual(item.valor)">
          {{item.valor}}
        </div>
      </div>

      <div class="tarimaCuadrito3"></div>
      <div *ngFor="let item of lista56">
        <div class="cuadros2"
          [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
          (click)="agregarPalcoIndividual(item.valor)">
          {{item.valor}}
        </div>
      </div>

      <div *ngFor="let item of lista44">
        <div class="cuadros2"
          [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
          (click)="agregarPalcoIndividual(item.valor)">
          {{item.valor}}
        </div>
      </div>
      <div class="clearFix"></div>
      <div class="tarimaCuadrito2 largo">I</div>
      <div class="tarimaLargaCalentura "></div>
      <div *ngFor="let item of lista57">
        <div class="cuadros2"
          [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
          (click)="agregarPalcoIndividual(item.valor)">
          {{item.valor}}
        </div>
      </div>


      <div *ngFor="let item of lista45">
        <div class="cuadros2"
          [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
          (click)="agregarPalcoIndividual(item.valor)">
          {{item.valor}}
        </div>
      </div>
      <div class="clearFix"></div>
      <div class="tarimaCuadrito2">M</div>
      <div *ngFor="let item of lista58">
        <div class="cuadros2"
          [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
          (click)="agregarPalcoIndividual(item.valor)">
          {{item.valor}}
        </div>
      </div>

      <div class="tarimaCuadrito4"></div>

      <div *ngFor="let item of lista59">
        <div class="cuadros2"
          [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
          (click)="agregarPalcoIndividual(item.valor)">
          {{item.valor}}
        </div>
      </div>


      <div *ngFor="let item of lista46">
        <div class="cuadros2"
          [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
          (click)="agregarPalcoIndividual(item.valor)">
          {{item.valor}}
        </div>
      </div>
      <div class="clearFix"></div>

      <div class="tarimaCuadrito2 tamanio">A</div>
      <div *ngFor="let item of lista60">
        <div class="cuadros2"
          [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
          (click)="agregarPalcoIndividual(item.valor)">
          {{item.valor}}
        </div>
      </div>
      <div *ngFor="let item of lista47">
        <div class="cuadros2"
          [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
          (click)="agregarPalcoIndividual(item.valor)">
          {{item.valor}}
        </div>
      </div>


      <div class="clearFix"></div>
      <div class="tarimaCuadrito2"></div>

      <div *ngFor="let item of lista61">
        <div class="cuadros2"
          [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
          (click)="agregarPalcoIndividual(item.valor)">
          {{item.valor}}
        </div>
      </div>
      <div *ngFor="let item of lista48">
        <div class="cuadros2"
          [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
          (click)="agregarPalcoIndividual(item.valor)">
          {{item.valor}}
        </div>
      </div>

      <!--ACA TERMINA LA PF-->
      <div class="clearFix margenArrib"></div>
      <div *ngFor="let item of lista49" class="margencuadrito">
        <div class="cuadros2"
          [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
          (click)="agregarPalcoIndividual(item.valor)">
          {{item.valor}}
        </div>
      </div>
      <div class="clearFix"></div>
      <div *ngFor="let item of lista50" class="margencuadrito">
        <div class="cuadros2"
          [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
          (click)="agregarPalcoIndividual(item.valor)">
          {{item.valor}}
        </div>
      </div>
      <div class="clearFix"></div>
      <div *ngFor="let item of lista51" class="margencuadrito">
        <div class="cuadros2"
          [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
          (click)="agregarPalcoIndividual(item.valor)">
          {{item.valor}}
        </div>
      </div>
      <div class="clearFix"></div>
      <div *ngFor="let item of lista52" class="margencuadrito">
        <div class="cuadros2"
          [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
          (click)="agregarPalcoIndividual(item.valor)">
          {{item.valor}}
        </div>
      </div>
      <div class="clearFix"></div>



    </div>

    <div class="localidadC">

      <div class="C2">
        <div *ngFor="let item of lista25" class="margencuadrito">
          <div class="cuadros2"
            [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
            (click)="agregarPalcoIndividual(item.valor)">
            {{item.valor}}
          </div>
        </div>
        <div class="clearFix"></div>
        <div *ngFor="let item of lista26">
          <div class="cuadros2"
            [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
            (click)="agregarPalcoIndividual(item.valor)">
            {{item.valor}}
          </div>
        </div>
        <div class="clearFix"></div>
        <div *ngFor="let item of lista27">
          <div class="cuadros2"
            [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
            (click)="agregarPalcoIndividual(item.valor)">
            {{item.valor}}
          </div>
        </div>
        <div class="clearFix"></div>
        <div *ngFor="let item of lista28">
          <div class="cuadros2"
            [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
            (click)="agregarPalcoIndividual(item.valor)">
            {{item.valor}}
          </div>
        </div>
        <div class="clearFix"></div>
        <div *ngFor="let item of lista29">
          <div class="cuadros2"
            [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
            (click)="agregarPalcoIndividual(item.valor)">
            {{item.valor}}
          </div>
        </div>
        <div class="clearFix"></div>

        <div *ngFor="let item of lista30">
          <div class="cuadros2"
            [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
            (click)="agregarPalcoIndividual(item.valor)">
            {{item.valor}}
          </div>
        </div>
        <div class="clearFix"></div>
        <div *ngFor="let item of lista31">
          <div class="cuadros2"
            [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
            (click)="agregarPalcoIndividual(item.valor)">
            {{item.valor}}
          </div>
        </div>
        <div class="tarimaMaster">MASTER</div>

        <div class="clearFix"></div>
        <div *ngFor="let item of lista32" class="margenTopPequeno">
          <div class="cuadros2"
            [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
            (click)="agregarPalcoIndividual(item.valor)">
            {{item.valor}}
          </div>
        </div>

        <div class="tarimaMaster2"></div>

        <div class="clearFix"></div>

        <div *ngFor="let item of lista33">
          <div class="cuadros2"
            [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
            (click)="agregarPalcoIndividual(item.valor)">
            {{item.valor}}
          </div>
        </div>
        <div class="clearFix"></div>
        <div *ngFor="let item of lista34">
          <div class="cuadros2"
            [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
            (click)="agregarPalcoIndividual(item.valor)">
            {{item.valor}}
          </div>
        </div>
        <div class="clearFix"></div>
        <div *ngFor="let item of lista35">
          <div class="cuadros2"
            [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
            (click)="agregarPalcoIndividual(item.valor)">
            {{item.valor}}
          </div>
        </div>
        <div class="clearFix"></div>
        <div *ngFor="let item of lista36">
          <div class="cuadros2"
            [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
            (click)="agregarPalcoIndividual(item.valor)">
            {{item.valor}}
          </div>
        </div>
        <div class="clearFix"></div>


      </div>


      <div class="C1">

        <div *ngFor="let item of lista13">
          <div class="cuadros2"
            [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
            (click)="agregarPalcoIndividual(item.valor)">
            {{item.valor}}
          </div>
        </div>
        <div class="clearFix"></div>

        <div *ngFor="let item of lista14">
          <div class="cuadros2"
            [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
            (click)="agregarPalcoIndividual(item.valor)">
            {{item.valor}}
          </div>
        </div>
        <div class="clearFix"></div>

        <div *ngFor="let item of lista15">
          <div class="cuadros2"
            [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
            (click)="agregarPalcoIndividual(item.valor)">
            {{item.valor}}
          </div>
        </div>
        <div class="clearFix"></div>
        <div *ngFor="let item of lista16">
          <div class="cuadros2"
            [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
            (click)="agregarPalcoIndividual(item.valor)">
            {{item.valor}}
          </div>
        </div>
        <div class="clearFix"></div>
        <div *ngFor="let item of lista17">
          <div class="cuadros2"
            [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
            (click)="agregarPalcoIndividual(item.valor)">
            {{item.valor}}
          </div>
        </div>
        <div class="clearFix"></div>
        <div *ngFor="let item of lista18">
          <div class="cuadros2"
            [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
            (click)="agregarPalcoIndividual(item.valor)">
            {{item.valor}}
          </div>
        </div>
        <div class="clearFix"></div>
        <div *ngFor="let item of lista19">
          <div class="cuadros2"
            [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
            (click)="agregarPalcoIndividual(item.valor)">
            {{item.valor}}
          </div>
        </div>
        <div class="clearFix"></div>
        <div *ngFor="let item of lista20">
          <div class="cuadros2"
            [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
            (click)="agregarPalcoIndividual(item.valor)">
            {{item.valor}}
          </div>
        </div>
        <div class="clearFix"></div>
        <div *ngFor="let item of lista21">
          <div class="cuadros2"
            [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
            (click)="agregarPalcoIndividual(item.valor)">
            {{item.valor}}
          </div>
        </div>
        <div class="clearFix"></div>
        <div *ngFor="let item of lista22">
          <div class="cuadros2"
            [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
            (click)="agregarPalcoIndividual(item.valor)">
            {{item.valor}}
          </div>
        </div>
        <div class="clearFix"></div>
        <div *ngFor="let item of lista23">
          <div class="cuadros2"
            [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
            (click)="agregarPalcoIndividual(item.valor)">
            {{item.valor}}
          </div>
        </div>
        <div class="clearFix"></div>
        <div *ngFor="let item of lista24">
          <div class="cuadros2"
            [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
            (click)="agregarPalcoIndividual(item.valor)">
            {{item.valor}}
          </div>
        </div>
        <div class="clearFix"></div>
      </div>

    </div>



    <div class="localidadD">

      <div *ngFor="let item of lista1">
        <div class="cuadros2"
          [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
          (click)="agregarPalcoIndividual(item.valor)">
          {{item.valor}}
        </div>
      </div>

      <div class="clearFix"></div>
      <div *ngFor="let item of lista2">
        <div class="cuadros2"
          [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
          (click)="agregarPalcoIndividual(item.valor)">
          {{item.valor}}
        </div>
      </div>
      <div class="clearFix"></div>
      <div *ngFor="let item of lista3">
        <div class="cuadros2"
          [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
          (click)="agregarPalcoIndividual(item.valor)">
          {{item.valor}}
        </div>
      </div>
      <div class="clearFix"></div>
      <div *ngFor="let item of lista4">
        <div class="cuadros2"
          [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
          (click)="agregarPalcoIndividual(item.valor)">
          {{item.valor}}
        </div>
      </div>
      <div class="clearFix"></div>
      <div *ngFor="let item of lista5">
        <div class="cuadros2"
          [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
          (click)="agregarPalcoIndividual(item.valor)">
          {{item.valor}}
        </div>
      </div>
      <div class="clearFix"></div>
      <div *ngFor="let item of lista6">
        <div class="cuadros2"
          [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
          (click)="agregarPalcoIndividual(item.valor)">
          {{item.valor}}
        </div>
      </div>
      <div class="clearFix"></div>
      <div *ngFor="let item of lista7">
        <div class="cuadros2"
          [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
          (click)="agregarPalcoIndividual(item.valor)">
          {{item.valor}}
        </div>
      </div>
      <div class="clearFix"></div>
      <div *ngFor="let item of lista8">
        <div class="cuadros2"
          [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
          (click)="agregarPalcoIndividual(item.valor)">
          {{item.valor}}
        </div>
      </div>
      <div class="clearFix"></div>
      <div *ngFor="let item of lista9">
        <div class="cuadros2"
          [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
          (click)="agregarPalcoIndividual(item.valor)">
          {{item.valor}}
        </div>
      </div>
      <div class="clearFix"></div>
      <div *ngFor="let item of lista10">
        <div class="cuadros2"
          [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
          (click)="agregarPalcoIndividual(item.valor)">
          {{item.valor}}
        </div>
      </div>
      <div class="clearFix"></div>
      <div *ngFor="let item of lista11">
        <div class="cuadros2"
          [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
          (click)="agregarPalcoIndividual(item.valor)">
          {{item.valor}}
        </div>
      </div>
      <div class="clearFix"></div>
      <div *ngFor="let item of lista12">
        <div class="cuadros2"
          [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros3':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
          (click)="agregarPalcoIndividual(item.valor)">
          {{item.valor}}
        </div>
      </div>

    </div>

    <div class="clearFix"></div>
    <div class="margencuadrito localidadB">

      <div *ngFor="let item of lista68">
        <div class="cuadros"
          [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
          (click)="agregarPalcoIndividual(item.valor)">
          {{item.valor}}
        </div>
      </div>
      <div class="clearFix"></div>
      <div *ngFor="let item of lista69">
        <div class="cuadros"
          [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
          (click)="agregarPalcoIndividual(item.valor)">
          {{item.valor}}
        </div>
      </div>
      <div class="clearFix"></div>
      <div *ngFor="let item of lista70">
        <div class="cuadros"
          [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
          (click)="agregarPalcoIndividual(item.valor)">
          {{item.valor}}
        </div>
      </div>
      <div class="clearFix"></div>
      <div *ngFor="let item of lista71">
        <div class="cuadros"
          [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
          (click)="agregarPalcoIndividual(item.valor)">
          {{item.valor}}
        </div>
      </div>
      <div class="clearFix"></div>
      <div *ngFor="let item of lista72">
        <div class="cuadros"
          [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
          (click)="agregarPalcoIndividual(item.valor)">
          {{item.valor}}
        </div>
      </div>
      <div class="clearFix"></div>


    </div>


  </div>
</div>






<div id="desplazate" *ngIf="evento?.mapa=='mapa22'">
  <p>
    <-- Desplázate en el mapa -->
  </p>
</div>
<div class="contenedor-mapa mt-5 pb-5" *ngIf="evento?.mapa=='mapa22'">

  <div class="mapa mg-0">
    <div class="tarimamap22">ESCENARIO</div>
    <div class="map22arriba">

      
      <div class="vacaxiones" (click)="abrirTickets(localidadCargadaBoletasVIP)">VACACIONES ZONA DE MENORES</div>



      <div class="cajaPrueba22">
        <div class="map22fila1"><div *ngFor="let item of lista1">
          <div class="cuadros"
            [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem', 'cuadros7':item.localidad=='promo'}"
            (click)="agregarPalcoIndividualID(item.valor,item.id)">
            {{item.valor}}
          </div>
        </div></div>
        <br><br>
        <div class="map22fila2"><div *ngFor="let item of lista2">
          <div class="cuadros"
            [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem', 'cuadros7':item.localidad=='promo'}"
            (click)="agregarPalcoIndividualID(item.valor,item.id)">
            {{item.valor}}
          </div>
        </div></div>
        <br><br>
        <div *ngFor="let item of lista3">
          <div class="cuadros"
            [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem', 'cuadros12':item.localidad=='monastery'}"
            (click)="agregarPalcoIndividualID(item.valor,item.id)">
            {{item.valor}}
          </div>
        </div>
        <div *ngFor="let item of lista4">
          <div class="cuadros"
            [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem'}"
            (click)="agregarPalcoIndividualID(item.valor,item.id)">
            {{item.valor}}
          </div>
        </div>
        <div *ngFor="let item of lista5">
          <div class="cuadros"
            [ngClass]="{'rojo':item.valor=='v', 'amarillo':item.valor=='p','opaco':item.valor=='l', 'cuadros4':item.localidad=='vip', 'cuadros10':item.localidad=='oro', 'cuadros5':item.localidad=='prem', 'cuadros8':item.localidad=='fumeteo'}"
            (click)="agregarPalcoIndividualID(item.valor,item.id)">
            {{item.valor}}
          </div>
        </div>
      </div> 
      <div class="clearFix"></div>
      <div class="frikimap22" (click)="abrirTickets(localidadCargadaBoletas)">ZONA FRIKI</div>
      <div class="clearFix"></div>
      <div class="jordanmap22" (click)="abrirTickets(localidadCargada)">ZONA JORDAN</div>
    </div>
    

  </div>
</div>